import React from 'react'
import classnames from 'classnames'
import './index.scss'
import Loading from '../loading'

export interface IPageContainerProps {
  className?: string
  children?: any
  loading?: boolean
  inner?: boolean
}

const PageContainer = ({ className, children, loading, inner }: IPageContainerProps) => {
  const loadingStyle = {
    height: 'calc(100vh - 184px)',
    overflow: 'hidden',
  }

  return (
    <div
      className={classnames(className, {
        contentInner: inner,
      })}
      style={loading ? loadingStyle : undefined}
    >
      {loading ? <Loading spinning /> : ''}
      {children}
    </div>
  )
}

export default PageContainer
